import { render, staticRenderFns } from "./UplodeImage.vue?vue&type=template&id=6fd44539&scoped=true&"
import script from "./UplodeImage.vue?vue&type=script&lang=js&"
export * from "./UplodeImage.vue?vue&type=script&lang=js&"
import style0 from "./UplodeImage.vue?vue&type=style&index=0&id=6fd44539&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fd44539",
  null
  
)

export default component.exports